export default "__VITE_ASSET__DF9MOGHU__";